import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import about1 from '../assets/img/about-1.jpg';
import about2 from '../assets/img/about-2.jpg';
import about3 from '../assets/img/about-3.jpg';
import about4 from '../assets/img/about-4.jpg';
import t1 from '../assets/img/testimonial-1.jpg';
import t2 from '../assets/img/testimonial-2.jpg';
import t3 from '../assets/img/testimonial-3.jpg';
import t4 from '../assets/img/testimonial-4.jpg';

const stats = [
  { num: '50K+',  label: 'Jobs Posted',   icon: 'fa-briefcase',  color: '#0066FF', bg: '#e8f0ff' },
  { num: '120K+', label: 'Job Seekers',   icon: 'fa-users',      color: '#00C896', bg: '#e6fff6' },
  { num: '8K+',   label: 'Companies',     icon: 'fa-building',   color: '#f59e0b', bg: '#fff8e6' },
  { num: '35K+',  label: 'Jobs Filled',   icon: 'fa-handshake',  color: '#8b5cf6', bg: '#f3eeff' },
];

const values = [
  { icon: 'fa-heart',       color: '#ef4444', bg: '#fff0f0', title: 'People First',      desc: 'We put job seekers and employers at the center of everything we build.' },
  { icon: 'fa-shield-alt',  color: '#0066FF', bg: '#e8f0ff', title: 'Trust & Safety',    desc: 'Every listing is verified. Every company is screened. No spam, ever.' },
  { icon: 'fa-bolt',        color: '#f59e0b', bg: '#fff8e6', title: 'Speed & Simplicity', desc: 'From search to apply in seconds. We remove friction at every step.' },
  { icon: 'fa-globe',       color: '#00C896', bg: '#e6fff6', title: 'Global Reach',       desc: 'Connecting talent and opportunity across 50+ countries worldwide.' },
];

const team = [
  { img: t1, name: 'Sarah Johnson',  role: 'CEO & Co-Founder',     social: { li: '#', tw: '#' } },
  { img: t2, name: 'Michael Chen',   role: 'CTO & Co-Founder',     social: { li: '#', tw: '#' } },
  { img: t3, name: 'Priya Sharma',   role: 'Head of Product',      social: { li: '#', tw: '#' } },
  { img: t4, name: 'James Williams', role: 'Head of Growth',       social: { li: '#', tw: '#' } },
];

const milestones = [
  { year: '2018', title: 'Founded',          desc: 'JobEntry was founded with a mission to simplify hiring for everyone.' },
  { year: '2019', title: '10K Users',        desc: 'Reached 10,000 registered users within the first year of launch.' },
  { year: '2021', title: 'Global Expansion', desc: 'Expanded to 20+ countries and partnered with Fortune 500 companies.' },
  { year: '2023', title: '100K+ Hired',      desc: 'Celebrated 100,000 successful job placements on the platform.' },
  { year: '2024', title: 'AI Matching',      desc: 'Launched AI-powered job matching for smarter, faster connections.' },
];

export default function About() {
  return (
    <>
      <PageHeader title="About Us" breadcrumb="About" />

      {/* ── Mission Section ── */}
      <section className="section-pad">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <div className="about-grid">
                <div className="about-img-wrap main"><img src={about1} alt="" /></div>
                <div className="about-img-wrap top-right"><img src={about2} alt="" /></div>
                <div className="about-img-wrap bottom-left"><img src={about3} alt="" /></div>
                <div className="about-img-wrap bottom-right"><img src={about4} alt="" /></div>
                <div className="about-badge-card">
                  <i className="fa fa-trophy"></i>
                  <div><strong>#1 Job Portal</strong><span>2024 Award</span></div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <span className="section-badge">Our Mission</span>
              <h2 className="section-title mt-2">We Connect Talent With Opportunity</h2>
              <p className="text-muted mb-4" style={{ lineHeight: 1.8 }}>
                JobEntry was built on a simple belief — finding the right job or the right person shouldn't be hard. We combine smart technology with a human touch to make hiring faster, fairer, and more effective for everyone.
              </p>
              <div className="about-features mb-4">
                {[
                  { icon: 'fa-check-circle', color: '#0066FF', text: 'AI-powered job matching for precise recommendations' },
                  { icon: 'fa-check-circle', color: '#00C896', text: 'Verified companies and trusted job listings only' },
                  { icon: 'fa-check-circle', color: '#f59e0b', text: 'Real-time alerts and one-click apply feature' },
                ].map((f, i) => (
                  <div className="about-feature" key={i}>
                    <div className="about-feature-icon" style={{ background: f.color + '18', color: f.color }}>
                      <i className={`fa ${f.icon}`}></i>
                    </div>
                    <p>{f.text}</p>
                  </div>
                ))}
              </div>
              <div className="about-cta">
                <Link to="/job-list" className="btn-grad">Browse Jobs <i className="fa fa-arrow-right ms-2"></i></Link>
                <Link to="/contact" className="btn-outline-grad">Contact Us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats ── */}
      <section className="about-stats-section">
        <div className="container">
          <div className="about-stats-grid">
            {stats.map((s, i) => (
              <div className="about-stat-card" key={i}>
                <div className="about-stat-icon" style={{ background: s.bg, color: s.color }}>
                  <i className={`fa ${s.icon}`}></i>
                </div>
                <div>
                  <span className="about-stat-num">{s.num}</span>
                  <span className="about-stat-label">{s.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Values ── */}
      <section className="section-pad bg-light-soft">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Our Values</span>
            <h2 className="section-title">What We Stand For</h2>
            <p className="section-sub">The principles that guide every decision we make</p>
          </div>
          <div className="about-values-grid">
            {values.map((v, i) => (
              <div className="about-value-card" key={i}>
                <div className="about-value-icon" style={{ background: v.bg, color: v.color }}>
                  <i className={`fa ${v.icon}`}></i>
                </div>
                <h5>{v.title}</h5>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Timeline ── */}
      <section className="section-pad">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Our Journey</span>
            <h2 className="section-title">How We Got Here</h2>
            <p className="section-sub">Key milestones in the JobEntry story</p>
          </div>
          <div className="about-timeline">
            {milestones.map((m, i) => (
              <div className={`about-timeline-item ${i % 2 === 0 ? 'left' : 'right'}`} key={i}>
                <div className="about-timeline-card">
                  <span className="about-timeline-year">{m.year}</span>
                  <h6>{m.title}</h6>
                  <p>{m.desc}</p>
                </div>
                <div className="about-timeline-dot"></div>
              </div>
            ))}
            <div className="about-timeline-line"></div>
          </div>
        </div>
      </section>

      {/* ── Team ── */}
      <section className="section-pad bg-light-soft">
        <div className="container">
          <div className="section-header">
            <span className="section-badge">Our Team</span>
            <h2 className="section-title">Meet the People Behind JobEntry</h2>
            <p className="section-sub">A passionate team dedicated to transforming how the world works</p>
          </div>
          <div className="about-team-grid">
            {team.map((m, i) => (
              <div className="about-team-card" key={i}>
                <div className="about-team-img-wrap">
                  <img src={m.img} alt={m.name} />
                  <div className="about-team-overlay">
                    <a href={m.social.li} className="about-team-social"><i className="fab fa-linkedin-in"></i></a>
                    <a href={m.social.tw} className="about-team-social"><i className="fab fa-twitter"></i></a>
                  </div>
                </div>
                <div className="about-team-info">
                  <h6>{m.name}</h6>
                  <span>{m.role}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <div className="cta-left">
              <h2>Ready to Join Our Story?</h2>
              <p>Be part of the 120,000+ professionals who found success with JobEntry.</p>
            </div>
            <div className="cta-right">
              <Link to="/login" className="cta-btn-white">Get Started Free</Link>
              <Link to="/job-list" className="cta-btn-outline">Browse Jobs</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
